import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  font-size: 14px;
  color: var(--dark-blue);
  overflow: hidden;
  max-width: 180px;
  word-break: break-word;
`;

type Props = { phone: string; dataTestId?: string };

const CMASummaryTableDataPhone = ({ phone, dataTestId }: Props) => <Container title={phone} data-test-id={dataTestId}>{phone}</Container>;

export default CMASummaryTableDataPhone;
